
class SerialSequenceCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;
    private namePatternTextField:MUITextField = null;
    private prefixTextField:MUITextField = null;
    private periodLabel:MUILabel = null;
    private typeTextField:MUITextField = null;
    private nullifySeriesDropdown:MUIButton = null;    

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, 'name-lbl', 'MUILabel');
        this.namePatternTextField = MUIOutlet(this, 'name-pattern-tf', 'MUITextField');
        this.namePatternTextField.setOnChangeText(this, function(this:SerialSequenceCell, control:MUITextField, value:string){
            this.serialSequence.namePattern = value.trim().length > 0 ? value.trim() : null;
        });
        this.prefixTextField = MUIOutlet(this, 'prefix-tf', 'MUITextField');
        this.prefixTextField.setOnChangeText(this, function(this:SerialSequenceCell, control:MUITextField, value:string){
            this.serialSequence.prefix = value;
        });
        this.periodLabel = MUIOutlet(this, 'period-lbl', 'MUILabel');
        this.typeTextField = MUIOutlet(this, 'type-tf', 'MUITextField');
        this.typeTextField.setOnChangeText(this, function(this:SerialSequenceCell, control:MUITextField, value:string){
            this.serialSequence.entityType = parseInt(value);
        });

        this.nullifySeriesDropdown = MUIOutlet(this, 'nullify-series-dd', 'MUIButton');
        this.nullifySeriesDropdown.setAction(this, function(){
            AppHelper.sharedInstance().showSelectNumberSerialSequenceViewControllerFromView(this.nullifySeriesDropdown, this.serialSequence.voidSequence, true, this, function(controller:SelectEntityViewController, sequence:NumberSerialSequence){
                this.serialSequence.voidSequence = sequence;
                this.nullifySeriesDropdown.title = sequence?.name;
            });
        });   


        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }
    
    private serialSequence:NumberSerialSequence = null;
    set item(i:NumberSerialSequence){
        this.serialSequence = i;
        this.nameLabel.text = i.name;
        this.namePatternTextField.text = i.namePattern;
        this.prefixTextField.text = i.prefix;
        this.periodLabel.text = i.period;
        this.typeTextField.text = i.entityType.toString();
        this.nullifySeriesDropdown.title = i.voidSequence?.name;

        // Period children render indented and read only: the server manages them.
        let is_child = i.parent != null;
        if (is_child) this.layer.classList.add('sub-cell');
        else this.layer.classList.remove('sub-cell');
        this.namePatternTextField.enabled = !is_child;
        this.prefixTextField.enabled = !is_child;
        this.typeTextField.enabled = !is_child;
        this.nullifySeriesDropdown.enabled = !is_child;
    }
}
